import { useEffect, useRef } from 'react';

type SearchParamsSyncValue = string | number | boolean;

export const useSearchParamsSync = <TValue extends SearchParamsSyncValue>(
    sync: (value: TValue) => void,
    value: TValue | null | undefined,
    enabled = true,
) => {
    const lastValueRef = useRef<TValue | null | undefined>(undefined);
    const syncRef = useRef(sync);

    useEffect(() => {
        syncRef.current = sync;
    }, [sync]);

    useEffect(() => {
        if (!enabled) {
            return;
        }

        if (value === undefined || value === null || value === '') {
            lastValueRef.current = undefined;

            return;
        }

        if (Object.is(lastValueRef.current, value)) {
            return;
        }

        lastValueRef.current = value;
        syncRef.current(value);
    }, [enabled, value]);
};
